export default {
  fg: "#fff",
  bg: "#1D180D",
  darkAccent: "#000",
  lightAccent: "#F8CF5A"
}
